import { render } from "./CardAuditoria.vue?vue&type=template&id=798bbeff&scoped=true"
import script from "./CardAuditoria.vue?vue&type=script&lang=js"
export * from "./CardAuditoria.vue?vue&type=script&lang=js"

import "./CardAuditoria.vue?vue&type=style&index=0&id=798bbeff&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798bbeff"]])

export default __exports__